import { render, staticRenderFns } from "./PayslipForm.vue?vue&type=template&id=71798239&"
import script from "./PayslipForm.vue?vue&type=script&lang=js&"
export * from "./PayslipForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports